import React from 'react';
import './App.css';
import {Box} from "@mui/material";
import Router from "./Router";
import {BehaviorSubject} from "rxjs";
import {Party} from "./_types/Party";

export const partyObserver: BehaviorSubject<Party | false | undefined> =
    new BehaviorSubject<Party | false | undefined>(false);
const App = () => {
    return (
        <div className="App">
            <Box className="app-shell" sx={{color: "white"}}>
                <div className="glow-blob glow-blob--blue"/>
                <div className="glow-blob glow-blob--pink"/>
                <Router/>
            </Box>
        </div>
    );
};

export default App;
